export default class LedgerEntry {
  constructor(_id, _paymentDueDate, _paymentMonth, _paymentYear, _rentAmount, _rentAmountPaid, _totalAmount, _feesOwed, _feeAmountPaid, _feeType, _feesOwed2, _feeAmountPaid2, _feeType2, _feesOwed3, _feeAmountPaid3, _feeType3, _feesOwed4, _feeAmountPaid4, _feeType4, _feesOwed5, _feeAmountPaid5, _feeType5, _feesOwed6, _feeAmountPaid6, _feeType6, _Balance) {
    this.id = _id;
    this.paymentDueDate = _paymentDueDate;
    this.paymentMonth = _paymentMonth;
    this.paymentYear = _paymentYear;
    this.rentAmount = _rentAmount;
    this.rentAmountPaid = _rentAmountPaid;
    this.totalAmount = _totalAmount;
    this.feesOwed = _feesOwed;
    this.feeAmountPaid = _feeAmountPaid;
    this.feeType = _feeType;
    this.feesOwed2 = _feesOwed2;
    this.feeAmountPaid2 = _feeAmountPaid2;
    this.feeType2 = _feeType2;
    this.feesOwed3 = _feesOwed3;
    this.feeAmountPaid3 = _feeAmountPaid3;
    this.feeType3 = _feeType3;
    this.feesOwed4 = _feesOwed4;
    this.feeAmountPaid4 = _feeAmountPaid4;
    this.feeType4 = _feeType4;
    this.feesOwed5 = _feesOwed5;
    this.feeAmountPaid5 = _feeAmountPaid5;
    this.feeType5 = _feeType5;
    this.feesOwed6 = _feesOwed6;
    this.feeAmountPaid6 = _feeAmountPaid6;
    this.feeType6 = _feeType6;
    this.Balance = _Balance;
  }
}
